import { useTheme, Grid, Box, Skeleton, Typography } from '@mui/material';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

const FormFieldset = props => {
  const theme = useTheme();
  const {
    label,
    children,
    isLoading,
    background = 'paper',
    sx
  } = props;
  return /*#__PURE__*/jsxs(Grid, {
    container: true,
    sx: {
      my: 3,
      ...sx
    },
    children: [/*#__PURE__*/jsx(Grid, {
      size: {
        xs: 12,
        md: 4
      },
      children: /*#__PURE__*/jsx(Box, {
        sx: {
          py: 2,
          pr: 2
        },
        children: isLoading ? /*#__PURE__*/jsx(Skeleton, {
          variant: "rectangular"
        }) : /*#__PURE__*/jsx(Typography, {
          variant: "subheader",
          sx: {
            textTransform: 'uppercase',
            color: theme => theme.palette.text.secondary
          },
          children: label
        })
      })
    }), /*#__PURE__*/jsx(Grid, {
      size: {
        xs: 12,
        md: 8
      },
      children: /*#__PURE__*/jsx(Box, {
        sx: {
          p: 2,
          boxShadow: 'none',
          borderRadius: 0,
          backgroundColor: background === 'default' ? theme.palette.background.default : theme.palette.background.paper
        },
        className: "MuiFormFieldset-Paper",
        children: isLoading ? /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(Skeleton, {
            variant: "rectangular",
            sx: {
              mb: 2
            }
          }), /*#__PURE__*/jsx(Skeleton, {
            variant: "rectangular",
            height: 60,
            sx: {
              mb: 2
            }
          }), /*#__PURE__*/jsx(Skeleton, {
            variant: "rectangular"
          })]
        }) : children
      })
    })]
  });
};

export { FormFieldset };
